import config from 'crm/config'

const taskApi = `${config.apiHost}/oem-task-system`

export default {
    list: {
        url: `${taskApi}/api/tasks`,
        type: 'GET',
    },
    remove: {
        url: `${taskApi}/api/tasks/{id}`,
        type: 'DELETE',
    },
    taskConfig: {
        url: `${taskApi}/api/task-configs`,
        type: 'GET',
    },
    updateTaskConfig: {
        url: `${taskApi}/api/task-configs`,
        type: 'PUT',
    },
    publish: {
        url: `${taskApi}/api/tasks/{id}/publish`,
        type: 'PUT',
    },
    exportData: {
        url: `${taskApi}/api/tasks/export`,
        type: 'GET',
    },
    // 导出引流物料
    exportDrainageData: {
        url: `${taskApi}/api/tasks/drainage-task/{id}/export`,
        type: 'GET',
    },
}
